import type { MonospaceAuditLog } from '#layers/data-model/public';
import { defineRelations, withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { User } from './user';
import { Workspace } from './workspace';

export const AuditLog = withItemType<MonospaceAuditLog>().defineCollection({
	name: 'MonospaceAuditLog',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: [
			'id',
			'timestamp',
			'action',
			'resourceType',
			'resourceId',
			'actorId',
			'actorIp',
			'outcome',
			'collectionId',
			'workspaceId',
		],
		endpoint: 'system/audit-logs',
	},
});

export const AuditLogRelations = defineRelations(AuditLog, ({ collection }) => ({
	actor: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceAuditLog.actorId',
			},
		}),
	},
	workspace: {
		to: collection(Workspace, {
			on: {
				'MonospaceWorkspace.id': 'MonospaceAuditLog.workspaceId',
			},
		}),
	},
}));
